import toNumber from 'lodash/toNumber';
import polyfillIntlNumberFormat from 'utils/polyfillIntlNumberFormat';

const stringifyNumber = (num: string | number) => {
  const number = toNumber(num);

  if (window.Intl) {
    return new Intl.NumberFormat('ru-RU').format(number);
  }

  return polyfillIntlNumberFormat(number);
};

export default stringifyNumber;
